import { useSelector } from 'react-redux';
import moment from 'moment';
import { AppDatePicker } from '@/layout/AppComponents';
import BtnOptions from './BtnOptions';
import Translator from '../../../../components/helpers/Translator';

const Report38Options = (props) => {
  const { handleOnSetFieldValue, handleOnSubmit, handleOnSave, values } = props;
  const locale = useSelector((state) => state.global.urlData.lang);

  return (
    <>
      <div className="row">
        <div className="col-lg-6">
          <AppDatePicker
            title={
              <Translator
                file="module-lawFinder"
                name="module.lf.filter.from"
              />
            }
            locale={locale}
            value={values.from}
            onChange={(opt) => handleOnSetFieldValue('from', opt)}
            placeholder="mm/yyyy"
            dateFormat="MM/Y"
            displayDateFormat="MM/YYYY"
            isClearable
            showMonthYearPicker
          />
        </div>
        <div className="col-lg-6">
          <AppDatePicker
            title={
              <Translator file="module-lawFinder" name="module.lf.filter.to" />
            }
            locale={locale}
            value={values.to}
            onChange={(opt) => handleOnSetFieldValue('to', opt)}
            placeholder="mm/yyyy"
            dateFormat="MM/Y"
            displayDateFormat="MM/YYYY"
            isClearable
            showMonthYearPicker
            minDate={
              values.from ? moment(values.from, 'MM/YYYY').toDate() : false
            }
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <BtnOptions
                isDisabled={!values.to || !values.from}
                handleOnSave={() => handleOnSave(true)}
                handleOnSubmit={() => handleOnSubmit()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Report38Options;
